import React from 'react';

export const InformationIcon = () => (
  <svg viewBox="0 0 32 32" fill="none" focusable="false" aria-hidden="true">
    <path
      d="M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM16 8a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm4 16.125h-8v-2.25h2.875v-5.75H13v-2.25h4.125v8H20v2.25z"
      fill="currentColor"
    />
  </svg>
);
